import { useContext } from "react";
import Card1 from "../Academy/Courses_Cards/Card1";
import { cardInfos } from "../../components/Data/datas";
import {
  academyPath,
  landingPath,
  learningToolsPath,
  qiraatPath,
  quranPath,
} from "../../components/routes/path";
import { Link } from "react-router-dom";
import { MdKeyboardArrowRight } from "react-icons/md";

import { TfiLayoutGrid4Alt } from "react-icons/tfi";
import { FaList } from "react-icons/fa6";
import Card2 from "../Academy/Courses_Cards/Card2";
import { AcademyContext } from "../Academy/AcademyContextDefinition";



const LearningTools = () => {
  const { search, handleSearch, toggle, handleToggle } =
    useContext(AcademyContext);
  return (
    <div className="bg-[#F7F7F7] p-5 sm:p-10 flex flex-col justify-between w-full">
      <div className="flex items-center p-4">
        <Link to={landingPath} className="hover:text-[#66B2FF]">
          <p className="text-sm sm:text-lg">Home</p>
        </Link>
        <MdKeyboardArrowRight className="mt-1" />
        <Link to={academyPath} className="hover:text-[#66B2FF]">
          <p className="text-sm sm:text-lg">Academy</p>
        </Link>
        <MdKeyboardArrowRight className="mt-1" />

        <p className="text-sm sm:text-lg">Learning Tools</p>
      </div>
      <div className="flex flex-col sm:flex-row justify-between w-full">
        <h1 className="font-bold text-3xl pb-2">Learning Tools</h1>
        <div className="flex justify-between items-center sm:gap-20">
          <input
            type="text"
            value={search.toLowerCase()}
            onChange={handleSearch}
            className="p-2 border-2 outline-1"
            placeholder="Search books.."
          />
          <div className={`flex gap-3 text-2xl `}>
            <TfiLayoutGrid4Alt
              onClick={() => handleToggle("Grid")}
              className={`${toggle == "Grid" && "text-[#004C97]"}`}
            />
            <FaList
              onClick={() => handleToggle("List")}
              className={`${toggle == "List" && "text-[#004C97]"}`}
            />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-10">
        {toggle === "List" ? (
          cardInfos
            .filter(
              (cardInfo) =>
                cardInfo.bookTitle.toLowerCase().includes(search) &&
                cardInfo.bookCaterory === "Learning Tools"
            )
            .map((cardInfo) => (
              <Card1
                key={cardInfo.id}
                {...cardInfo}
                to={`${academyPath}/${cardInfo.id}`}
              />
            ))
        ) : (
          <div className="grid sm:grid-cols-4 gap-5 gap-y-16 mt-10 ">
            {cardInfos
              .filter(
                (cardInfo) =>
                  cardInfo.bookTitle.toLowerCase().includes(search) &&
                  cardInfo.bookCaterory === "Learning Tools"
              )
              .map((cardInfo) => (
                <Card2
                  key={cardInfo.id}
                  {...cardInfo}
                  toCategory={
                    cardInfo.bookCaterory == "QUR'AN"
                      ? quranPath
                      : cardInfo.bookCaterory == "Learning Tools"
                      ? learningToolsPath
                      : cardInfo.bookCaterory == "Key Principles of Qira’at" &&
                        qiraatPath
                  }
                  to={`${academyPath}/${cardInfo.id}`}
                />
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LearningTools;
